import { api, writeDB } from './store';

export interface Country {
  name: string;
  countryCode: string;
}

export async function getCountries(): Promise<void> {
  const countries = writeDB.table('countries').all;
  if (countries.length === 0) {
    const response = await api.indexCountries();
    if (response.data) {
      writeDB.table('countries').upsert(response.data);
    }
  }
}
